import { Button, Cell, Grid, HFlow } from 'bold-ui'
import { useAlert } from 'components/alert'
import { useErrorHandler } from 'components/error'
import { Form, FormRenderProps, PecFormApi, resetAllFieldStates, TextField } from 'components/form'
import { useSalvarLoteImunobiologicoMutation } from 'graphql/hooks.generated'
import { useServerTime } from 'hooks/useServerTime'
import { metaPath } from 'util/metaPath'

import { ImunobiologicoSelectField, ImunobiologicoSelectModel } from '../components/ImunobiologicoSelectField'
import {
  LoteImunobiologicoFabricanteSelectField,
  LoteImunobiologicoFabricanteSelectFieldModel,
} from '../components/LoteImunobiologicoFabricanteSelectField'
import { LoteImunobiologicoValidadeDateField } from '../list/LoteImunobiologicoValidadeDateField'
import convertModelToInput from '../LoteImunoModelnputConverter'
import { validateLoteImunobiologico } from '../validator/validator-loteImunobiologico'

export interface LoteImunobiologicoFormModel {
  id?: ID
  lote?: string
  fabricante?: LoteImunobiologicoFabricanteSelectFieldModel
  imunobiologico?: ImunobiologicoSelectModel
  validade?: LocalDate
}

export interface LoteImunobiologicoTooltipAddFormProps {
  onClose(): void
  onCancel(): void
  onSuccess(): void
}

const path = metaPath<LoteImunobiologicoFormModel>()

export default function LoteImunobiologicoTooltipAddForm(props: Readonly<LoteImunobiologicoTooltipAddFormProps>) {
  const { onClose, onSuccess } = props
  const alert = useAlert()
  const errorHandler = useErrorHandler()
  const [salvar] = useSalvarLoteImunobiologicoMutation()

  const { getServerTimeNow } = useServerTime()
  const serverTimeNow = getServerTimeNow()

  const renderForm = (formProps: FormRenderProps<LoteImunobiologicoFormModel>) => {
    return (
      <>
        <Grid wrap gap={1}>
          <Cell xs={12} md={5}>
            <TextField name={path.lote} label='Lote' required maxLength={30} />
          </Cell>
          <Cell xs={12} md={7}>
            <LoteImunobiologicoFabricanteSelectField name={path.fabricante} label='Fabricante' required />
          </Cell>
          <Cell xs={12} md={7}>
            <ImunobiologicoSelectField name={path.imunobiologico} label='Imunobiológico' required semRegras />
          </Cell>
          <Cell xs={12} md={5}>
            <LoteImunobiologicoValidadeDateField
              name={path.validade}
              minDate={serverTimeNow}
              required
              icon='calendarOutline'
            />
          </Cell>
        </Grid>
        <HFlow justifyContent='flex-end' style={{ marginTop: '1rem' }}>
          <Button size='small' onMouseDown={(e) => e.preventDefault()} onClick={handleClose(formProps)}>
            Fechar
          </Button>
          <Button size='small' kind='primary' onClick={formProps.handleSubmit}>
            Adicionar
          </Button>
        </HFlow>
      </>
    )
  }

  const handleClose = (formProps: FormRenderProps) => () => {
    onClose()
    setTimeout(formProps.form.reset)
  }

  const submitForm = (form: LoteImunobiologicoFormModel, formApi: PecFormApi) => {
    return salvar({ variables: { input: convertModelToInput(form) } })
      .then(() => {
        alert('success', 'Lote de imunobiológico foi salvo com sucesso')
        resetAllFieldStates(formApi)
        setTimeout(formApi.reset)
        onSuccess()
      })
      .catch(errorHandler)
  }

  return (
    <Form<LoteImunobiologicoFormModel>
      render={renderForm}
      onSubmit={submitForm}
      validate={validateLoteImunobiologico(serverTimeNow)}
    />
  )
}
